import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect, useMemo, createContext } from 'react';
export const ThemeContext = createContext(null);
const ThemeProvider = ({ defaultTheme = 'light', children }) => {
    const [theme, setTheme] = useState(() => {
        return localStorage.getItem('theme') || defaultTheme;
    });
    useEffect(() => {
        localStorage.setItem('theme', theme);
        document.documentElement.setAttribute('data-theme', theme);
    }, [theme]);
    const toggleTheme = () => {
        setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
    };
    const values = useMemo(() => ({
        theme,
        setTheme,
        toggleTheme
    }), [theme]);
    return _jsx(ThemeContext.Provider, { value: values, children: children });
};
export default ThemeProvider;
